"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOrganicKeywordSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.UpdateOrganicKeywordSchema = typebox_1.Type.Object({
    keyword: ruby_1.KeywordSchema,
    country: core_1.CountrySchema,
});
